import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { history } from "../../../routers/AppRouter";
import moment from 'moment';
import styled from 'styled-components'
import { useTable, useRowSelect } from 'react-table';
import { connect } from "react-redux";

import { getClients } from '../../../actions/clients';
import MainButton from '../../../components/MainButton';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const Title = styled.div`
  cursor: pointer;
`;

const ButtonStyle = styled.button`
  cursor: pointer;
`;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    )
  }
);

const handleEditRow = (d) => {
  history.push({
    pathname: `client/${d.id}`,
    state: {
      data: d,
    },
  });
};

const createPost = () => {
  history.push('/client')
};

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    hooks => {
      hooks.allColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  );

  // Render the UI for your table
  return (
    <>
      <HeadingContainer>
        <StyledHeading>Clients</StyledHeading>
        <MainButton title="Create a Client" onClick={() => createPost()} />
      </HeadingContainer>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.slice(0, 500).map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <p>Selected Rows: {Object.keys(selectedRowIds).length}</p>
      <pre>
        <code>
          {JSON.stringify(
            {
              selectedRowIds: selectedRowIds,
              'selectedFlatRows[].original': selectedFlatRows.map(
                d => d.original
              ),
            },
            null,
            2
          )}
        </code>
      </pre>
    </>
  )
}

function ClientList(props) {

  useEffect(() => {
    props.getClients();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Client Info',
        columns: [
          // {
          //   Header: 'Item ID',
          //   accessor: data => {
          //     return <Title onClick={() => handleEditRow(data)}>{data.id}</Title>;
          //   },
          // },
          {
            Header: 'Client ID',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data)}>{data.id}</Title>
            },
          },
          {
            Header: 'Company',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data)}>{data.company}</Title>
            },
          },
          {
            Header: 'Notes',
            accessor: d => {
              return <Title>{d.notes}</Title>
            },
          },
          {
            Header: 'Status',
            accessor: d => {
              if (d.active === false) {
                return 'Not Active';
              } else if (d.active === true) {
                return 'Active';
              } else {
                return 'not set'
              }
            },
          },
          {
            Header: 'Created At',
            accessor: d => {
              return moment(d.createdAt).format('MMM. Do, YYYY');
            }
          },
          {
            Header: 'Edit',
            accessor: data => {
              return <ButtonStyle onClick={() => handleEditRow(data)}>Edit</ButtonStyle>;
            },
          },
        ],
      },
    ],
    []
  );

  return (
    <Styles>
      <Table columns={columns} data={props.clients} />
    </Styles>
  )
}

const mapStateToProps = (state) => {
  return {
    clients: state.clients.data
  };
};

const mapDispatchToProps = (dispatch) => ({
  getClients: () => dispatch(getClients()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientList);
